// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n  * MEW ALERT STYLES\n  */\n.mew-alert[data-v-14642b1f] {\n  border-radius: 8px;\n}\n.mew-alert .close-btn[data-v-14642b1f] {\n  height: auto;\n  width: auto;\n}", ""]);
// Exports
module.exports = exports;
